import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { GruppenModule } from '../../../projects/kiene-core/src/lib/components/gruppen/gruppen.module';
import { KeyValueListModule } from '../../../projects/kiene-core/src/lib/components/key-value-list/key-value-list.module';
import { UnterschriftenModule } from '../../../projects/kiene-core/src/lib/components/unterschriften/unterschriften.module';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { OhrmarkeModule } from '../../../projects/kiene-core/src/lib/ohrmarke/ohrmarke.module';
import { LocalStorageModule } from '../../../projects/kiene-core/src/lib/services/local-storage/local-storage.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { AnwendungsSelectorModule } from '../components/anwendungs-selector/anwendungs-selector.module';
import { ArticleScanAutocompleteModule } from '../components/article-scan-autocomplete/article-scan-autocomplete.module';
import { ComponentsModule } from '../components/components.module';
import { DeleteButtonModule } from '../components/delete-button/delete-button.module';
import { DiagnoseSelectorModule } from '../components/diagnose-selector/diagnose-selector.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { TabinfoModule } from '../components/tabinfo/tabinfo.module';
import { TierartSelectorModule } from '../components/tierart-selector/tierart-selector.module';
import { KieneDirectivesModule } from '../directives/kiene-directives.module';
import { LaboratoryModule } from '../laboratory/laboratory.module';
import { AbgabebelegDetailsComponent } from './abgabebeleg/abgabebeleg-details/abgabebeleg-details.component';
import { HoherPreisDialogComponent } from './abgabebeleg/abgabebeleg-details/hoher-preis-dialog/hoher-preis-dialog.component';
import { IdentifikationDialogComponent } from './abgabebeleg/abgabebeleg-details/identifikation-dialog/identifikation-dialog.component';
import { MeldungKorrekturDialogComponent } from './abgabebeleg/abgabebeleg-details/meldung-korrektur-dialog/meldung-korrektur-dialog.component';
import { PositionDetailsDialogComponent } from './abgabebeleg/abgabebeleg-details/position-details-dialog/position-details-dialog.component';
import { AbgabebelegWarenkorbDialogComponent } from './abgabebeleg/abgabebeleg-warenkorb-dialog/abgabebeleg-warenkorb-dialog.component';
import { AbgabebelegComponent } from './abgabebeleg/abgabebeleg.component';
import { AbgabebelegService } from './abgabebeleg/abgabebeleg.service';
import { BelegVorlageDetailsDialogComponent } from './abgabebeleg/belege-vorlage-dialog/beleg-vorlage-details-dialog/beleg-vorlage-details-dialog.component';
import { BelegeVorlageDialogComponent } from './abgabebeleg/belege-vorlage-dialog/belege-vorlage-dialog.component';
import { ChangeArtikelmengeDialogComponent } from './abgabebeleg/change-artikelmenge-dialog/change-artikelmenge-dialog.component';
import { CheckBehandlungAbgabeDialogComponent } from './abgabebeleg/check-behandlung-abgabe-dialog/check-behandlung-abgabe-dialog.component';
import { HotKeyDetailsDialogComponent } from './abgabebeleg/hot-key-details-dialog/hot-key-details-dialog.component';
import { HotKeyListDialogComponent } from './abgabebeleg/hot-key-list-dialog/hot-key-list-dialog.component';
import { MeldungenGenerierenDialogComponent } from './abgabebeleg/meldungen-generieren-dialog/meldungen-generieren-dialog.component';
import { BehandlungsanfrageDetailComponent } from './behandlungsanfrage/behandlungsanfrage-detail/behandlungsanfrage-detail.component';
import { BehandlungsanfrageDetailService } from './behandlungsanfrage/behandlungsanfrage-detail/behandlungsanfrage-detail.service';
import { BehandlungsanfrageComponent } from './behandlungsanfrage/behandlungsanfrage.component';
import { BehandlungsanfrageService } from './behandlungsanfrage/behandlungsanfrage.service';
import { BelegPositionModule } from './beleg-position/beleg-position.module';
import { BestandsbesuchprotokollDetailsComponent } from './bestandsbesuchsprotokoll/bestandsbesuchprotokoll-details/bestandsbesuchprotokoll-details.component';
import { BestandsbesuchsprotokollUebersichtComponent } from './bestandsbesuchsprotokoll/bestandsbesuchsprotokoll-uebersicht/bestandsbesuchsprotokoll-uebersicht.component';
import { BestandsbesuchsprotokollComponent } from './bestandsbesuchsprotokoll/bestandsbesuchsprotokoll.component';

import { DocumentsRoutingModule } from './documents-routing.module';
import { DocumentsComponent } from './documents.component';
import { AutoUploadDialogComponent } from './dokumente/auto-upload-dialog/auto-upload-dialog.component';
import { CreateDokumentDialogComponent } from './dokumente/create-dokument-dialog/create-dokument-dialog.component';
import { CreateNotschlachtbescheinigungDialogComponent } from './dokumente/create-notschlachtbescheinigung-dialog/create-notschlachtbescheinigung-dialog.component';
import { NotschlachtVorlagePreviewDialogComponent } from './dokumente/create-notschlachtbescheinigung-dialog/vorlage-preview-dialog.component';
import { DokumentTypeSelectionDialogComponent } from './dokumente/dokument-type-selection-dialog/dokument-type-selection-dialog.component';
import { DokumenteOverviewComponent } from './dokumente/dokumente-overview/dokumente-overview.component';
import { DokumenteTabViewComponent } from './dokumente/dokumente-tab-view/dokumente-tab-view.component';
import { DokumenteComponent } from './dokumente/dokumente.component';
import { UploadSonstigeDateiDialogComponent } from './dokumente/upload-sonstige-datei-dialog/upload-sonstige-datei-dialog.component';
import { DowloadAlleDokumenteDialogComponent } from './dowload-alle-dokumente-dialog/dowload-alle-dokumente-dialog.component';
import { GruppenverwaltungModule } from './gruppenverwaltung/gruppenverwaltung.module';
import { LaborComponent } from './labor/labor.component';
import { MassnahmenplanRindDetailsComponent } from './massnahmenplan/massnahmenplan-rind/massnahmenplan-rind-details/massnahmenplan-rind-details.component';
import { MassnahmenplanRindKurzDialogComponent } from './massnahmenplan/massnahmenplan-rind/massnahmenplan-rind-kurz-dialog/massnahmenplan-rind-kurz-dialog.component';
import { MassnahmenplanRindComponent } from './massnahmenplan/massnahmenplan-rind/massnahmenplan-rind.component';
import { MassnahmenplanSchweinDetailsComponent } from './massnahmenplan/massnahmenplan-schwein/massnahmenplan-schwein-details/massnahmenplan-schwein-details.component';
import { MassnahmenplanSchweinComponent } from './massnahmenplan/massnahmenplan-schwein/massnahmenplan-schwein.component';
import { MassnahmenplanComponent } from './massnahmenplan/massnahmenplan.component';
import { CreateMeldungenGebuehrenDialogComponent } from './meldungen/create-meldungen-gebuehren-dialog/create-meldungen-gebuehren-dialog.component';
import { GenerateNullmeldungDialogComponent } from './meldungen/generate-nullmeldung-dialog/generate-nullmeldung-dialog.component';
import { MeldungDetailsDialogComponent } from './meldungen/meldung-details-dialog/meldung-details-dialog.component';
import { MeldungenComponent } from './meldungen/meldungen.component';
import { TAMAusHITDialogComponent } from './meldungen/tamaus-hitdialog/tamaus-hitdialog.component';
import { TierwohlprotokollRindDetailsComponent } from './tierwohlprotokoll/tierwohlprotokoll-rind/tierwohlprotokoll-rind-details/tierwohlprotokoll-rind-details.component';
import { TierwohlprotokollRindComponent } from './tierwohlprotokoll/tierwohlprotokoll-rind/tierwohlprotokoll-rind.component';
import { TierwohlprotokollSchweinDetailsComponent } from './tierwohlprotokoll/tierwohlprotokoll-schwein/tierwohlprotokoll-schwein-details/tierwohlprotokoll-schwein-details.component';
import { TierwohlprotokollSchweinComponent } from './tierwohlprotokoll/tierwohlprotokoll-schwein/tierwohlprotokoll-schwein.component';
import { BioSicherheitsPlanSchweinComponent } from './bio-sicherheits-plan-schwein/bio-sicherheits-plan-schwein.component';
import { BioSicherheitsplanUebersichtComponent } from './bio-sicherheitsplan-uebersicht/bio-sicherheitsplan-uebersicht.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CsvUploadDialogComponent } from './massnahmenplan/csv-upload-dialog/csv-upload-dialog.component';
import { BioSicherheitsPlanRindComponent } from './bio-sicherheits-plan-rind/bio-sicherheits-plan-rind.component';
import { BioSicherheitsPlanRindUebersichtComponent } from './bio-sicherheits-plan-rind-uebersicht/bio-sicherheits-plan-rind-uebersicht.component';
import { EvaluationsbogenSchweinComponent } from './evaluationsbogen-schwein/evaluationsbogen-schwein.component';
import { EvaluationsbogenSchweinUebersichtComponent } from './evaluationsbogen-schwein-uebersicht/evaluationsbogen-schwein-uebersicht.component';

@NgModule({
    declarations: [
        DocumentsComponent,
        AbgabebelegComponent,
        AbgabebelegDetailsComponent,
        CheckBehandlungAbgabeDialogComponent,
        BehandlungsanfrageComponent,
        BehandlungsanfrageDetailComponent,
        BestandsbesuchsprotokollComponent,
        BestandsbesuchprotokollDetailsComponent,
        DokumenteComponent,
        AutoUploadDialogComponent,
        CreateDokumentDialogComponent,
        CreateNotschlachtbescheinigungDialogComponent,
        NotschlachtVorlagePreviewDialogComponent,
        DokumentTypeSelectionDialogComponent,
        DokumenteTabViewComponent,
        LaborComponent,
        MassnahmenplanComponent,
        MassnahmenplanRindComponent,
        MassnahmenplanRindDetailsComponent,
        MassnahmenplanSchweinComponent,
        MassnahmenplanSchweinDetailsComponent,
        MeldungenComponent,
        MeldungenGenerierenDialogComponent,
        CreateMeldungenGebuehrenDialogComponent,
        ChangeArtikelmengeDialogComponent,
        CsvUploadDialogComponent,
        IdentifikationDialogComponent,
        GenerateNullmeldungDialogComponent,
        DowloadAlleDokumenteDialogComponent,
        MeldungDetailsDialogComponent,
        MeldungKorrekturDialogComponent,
        AbgabebelegWarenkorbDialogComponent,
        MassnahmenplanRindKurzDialogComponent,
        TierwohlprotokollRindComponent,
        TierwohlprotokollSchweinComponent,
        BestandsbesuchsprotokollUebersichtComponent,
        TierwohlprotokollRindDetailsComponent,
        TierwohlprotokollSchweinDetailsComponent,
        TAMAusHITDialogComponent,
        DokumenteOverviewComponent,
        UploadSonstigeDateiDialogComponent,
        BelegeVorlageDialogComponent,
        BelegVorlageDetailsDialogComponent,
        HotKeyListDialogComponent,
        HotKeyDetailsDialogComponent,
        PositionDetailsDialogComponent,
        HoherPreisDialogComponent,
        BioSicherheitsPlanSchweinComponent,
        BioSicherheitsplanUebersichtComponent,
        BioSicherheitsPlanRindComponent,
        BioSicherheitsPlanRindUebersichtComponent,
        EvaluationsbogenSchweinComponent,
        EvaluationsbogenSchweinUebersichtComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatPaginatorModule,
        MatRadioModule,
        MatDividerModule,
        MatBadgeModule,
        MatTreeModule,
        MatTableModule,
        MatListModule,
        KieneAutocompleteModule,
        KieneTableModule,
        DocumentsRoutingModule,
        UnterschriftenModule,
        GruppenverwaltungModule,
        BelegPositionModule,
        ArticleScanAutocompleteModule,
        TierartSelectorModule,
        AnwendungsSelectorModule,
        DiagnoseSelectorModule,
        DragDropModule,
        DeleteButtonModule,
        TabinfoModule,
        LaboratoryModule,
        OhrmarkeModule,
        MatSidenavModule,
        MatStepperModule,
        MatAutocompleteModule,
        MatTooltipModule,
        GruppenModule,
        DirectivesModule,
        KieneDirectivesModule,
        ComponentsModule,
        KeyValueListModule,
        LocalStorageModule,
        GoogleChartsModule,
        TextFieldModule,
        NgOptimizedImage,
    ],
    providers: [AbgabebelegService, BehandlungsanfrageService, BehandlungsanfrageDetailService],
})
export class DocumentsModule {}
